// @ts-nocheck
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ContentContainer from "../../layout/ContentContainer";
import MaskedField from "../../common/inputs/maskedInput/MaskedField";
import SelectProfiles from "../../common/inputs/select/SelectProfiles";
import SubmitButton from "../../common/buttons/submitButton/SubmitButton";
import TextField from "../../common/inputs/textInput/TextField";
import styled from "styled-components";
import { IRegisterDTO } from "../../../types/userTypes";
import { useProfiles } from "../../../hooks/useProfiles";
import { registerInitValues, registerValidationSchema } from "../authHelpers";
import { Mask } from "../../../utils/constants/constants";
import FormSection from "../../common/forms/FormSection";
import authService from "../../../services/authServices";
import { getNotEmptyFields } from "../../../utils/objectUtils";
import { showServerErrors } from "../../../utils/errorsUtils";
import { useHistory } from "react-router-dom";
import { ISelectOption } from "components/common/inputs/inputTypes";
import NewSelectStatystics from "components/common/inputs/select/NewSelectStatystics";
import { createUser } from "services/usersServices";
import Button from "components/common/buttons/basicButton/Button";
import { ButtonVariant } from "components/common/buttons/buttonTypes";
import NewButton, {
  NewButtonVariant,
} from "components/common/buttons/basicButton/NewButton";

const SingleColumn = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;

  & > p {
    text-align: center;
  }

  & > * {
    width: 280px;
  }
  /* align-items: center; */
`;

const SingleRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 280px);
  column-gap: 5px;
`;

const ImageBox = styled.div<{ isAddMenuOpen: any }>`
  position: ${(props) => (props.isAddMenuOpen ? "absolute" : "unset")};

  top: 0;
  left: 0;
  height: 105px;
  background: rgba(0, 145, 255, 1);
  width: 312px;
  display: flex;
  align-items: center;
  z-index: 99;
  transition: all 3s;

  & > * {
    margin-bottom: unset;
  }
`;

interface Props {
  isAddMenuOpen?: any;
  academyBranches?: { label: string; value: number | string }[];
}

const RegisterForm: React.FC<Props> = ({ isAddMenuOpen, academyBranches }) => {
  // const [selectedItem, setSelectedItem] =
  //   useState<{ value: number; label: string } | null>(null);
  const { t } = useTranslation();

  const [academyBranch, setAcademyBranch] =
    useState<{ value: string; label: string } | null>(null);

  const handleSubmit = async (values: IRegisterDTO) => {
    const { Email, FirstName, LastName, Position, PhoneNumber } = values;
    try {
      await createUser(
        Email,
        FirstName,
        LastName,
        Position,
        PhoneNumber,
        academyBranch?.value,
      );
      toast.success(t("access.employeeAdded"));
      window.location.reload();
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`${error.response.data.message}`);
      } else {
        toast.error(error?.response?.data?.Errors?.Message[0]);
      }
    }
  };

  return (
    <>
      <Formik
        initialValues={registerInitValues}
        onSubmit={handleSubmit}
        validationSchema={registerValidationSchema}
      >
        {({ values, isSubmitting }) => (
          <Form
            className="flex"
            style={{
              display: "flex",
              height: "100%",
              width: "100%",
            }}
          >
            <SingleColumn style={{ alignItems: "center", paddingLeft: "15px" }}>
              <p>{t("access.basicData")}</p>
              {/* <NewSelectStatystics
                name="Profile"
                items={profiles}
                label="Profil"
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                style={{ width: "280px", marginBottom: "20px" }}
                // defaultValue={values.profile}
              /> */}

              <NewSelectStatystics
                name="AcademyId"
                items={academyBranches}
                label={t("nav.club")}
                style={{
                  width: "280px",
                  backgroundColor: "rgba(0,0,0,0.1)",
                  height: "48px",
                  borderRadius: "8px",
                }}
                // @ts-ignore
                selectedItem={academyBranch}
                setSelectedItem={setAcademyBranch}
              />

              <TextField
                name="FirstName"
                label={t("shop.firstName")}
                style={{ paddingTop: "12px" }}
              />
              <TextField name="LastName" label={t("shop.lastName")} />
            </SingleColumn>

            <SingleColumn style={{ alignItems: "center" }}>
              <p>{t("common.email")}</p>
              <TextField name="Email" label={t("common.email")} />
            </SingleColumn>
            <SingleColumn>
              <p>&nbsp;</p>

              <MaskedField
                mask={Mask.Phone}
                name="PhoneNumber"
                label={t("staff.phoneNumber")}
                placeholder={t("events.fillIn")}
              />
              <TextField
                name="Position"
                label={t("staff.position")}
                type="text"
                style={{ marginTop: "15px" }}
              />

              <NewButton
                variant={NewButtonVariant.Primary}
                type="submit"
                isLoading={isSubmitting}
                style={{
                  width: "280px",
                  marginTop: "439px",
                }}
              >
                {t("common.add")}
              </NewButton>
            </SingleColumn>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default RegisterForm;
